import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class UserServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
}

export const UserService = new UserServiceClass({
  api_version: 2,
  resource: 'referrals/list'
});
